import { useQuery } from "@tanstack/react-query";

import { useGraphQLClient } from "@package/graphql/react";
import { graphql } from "../graphql";

export const sourcesQueryKey = ["sources"] as const;

export const useSources = () => {
  const graphql = useGraphQLClient();
  return useQuery({
    queryKey: sourcesQueryKey,
    queryFn: async () => graphql.execute(sourcesQuery).then((res) => res.data?.source),
  });
};

const sourcesQuery = graphql(`
  query Sources {
    source {
      id
      name
    }
  }
`);
